/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_ErrorInputs */

const en_colleague_error = /** @type {(inputs: Colleague_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load colleague tickets`)
};

const ja_colleague_error = /** @type {(inputs: Colleague_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同僚のチケットを読み込めませんでした`)
};

const fr_colleague_error = /** @type {(inputs: Colleague_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger les tickets des collègues`)
};

const de_colleague_error = /** @type {(inputs: Colleague_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kollegen-Tickets konnten nicht geladen werden`)
};

/**
* | output |
* | --- |
* | "Could not load colleague tickets" |
*
* @param {Colleague_ErrorInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_error = /** @type {((inputs?: Colleague_ErrorInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_ErrorInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_error(inputs)
	if (locale === "ja") return ja_colleague_error(inputs)
	if (locale === "fr") return fr_colleague_error(inputs)
	return de_colleague_error(inputs)
});